/**
 * Les bloqueurs de publicité (listes EasyList FR d'uBlock Origin, AdBlock, Adblock Plus…) bloquent les adresses qui
 * contiennent « publicite » : la requête échoue sans même partir (net::ERR_BLOCKED_BY_CLIENT dans la console).
 * On compare un appel témoin qui contient ce mot à un appel témoin qui ne le contient pas : sans connexion, la réponse
 * du serveur est un refus (401), mais elle arrive ; seul le premier échoue quand un bloqueur est actif.
 */
export const MESSAGE_BLOQUEUR = "Un bloqueur de publicité bloque le mode Publicité (vidéos, diaporama) : "
    + "désactivez-le pour ce site (icône de l'extension, « ne pas bloquer sur ce site »), puis rechargez la page.";

export async function bloqueurDePubActif(api, envoyer = (...args) => window.fetch(...args)) {
    const essai = url => envoyer(url, {method: "GET", credentials: "omit", cache: "no-store", headers: {Accept: "application/json"}})
        .then(() => true, () => false);
    const [avecLeMot, sansLeMot] = await Promise.all([
        essai(`${api}/api/publicite/videos`),
        essai(`${api}/api/telephonie/etat`),
    ]);

    return !avecLeMot && sansLeMot;
}
